import { PageHero } from "@/components/site/Sections";
import { CtaButton } from "@/components/site/CtaButton";
import { Reveal } from "@/components/site/Reveal";
import { IMAGES } from "@/data/content";

const STEPS = [
  { n: "1", title: "Send the Property", desc: "Provide the address, auction link, parcel, auction date and maximum bid if relevant." },
  { n: "2", title: "Select Service", desc: "Choose Pre-Auction, $2,000 Acquisition Support, $3,500 Acquisition + Possession, Financing or a custom service." },
  { n: "3", title: "Property Review", desc: "Vertexhub organizes available information and coordinates the requested inspection." },
  { n: "4", title: "Auction / Acquisition", desc: "You participate in the transaction while Vertexhub provides applicable support." },
  { n: "5", title: "Post-Purchase", desc: "Vertexhub tracks and coordinates applicable post-sale processes." },
  { n: "6", title: "Property Ready", desc: "Transition toward recorded ownership, lawful possession and property stabilization." },
];

export default function HowItWorks() {
  return (
    <div>
      <PageHero
        eyebrow="How It Works"
        title="Submit a Property and Request Service in Minutes."
        subtitle="You find the deal. Vertexhub helps handle what comes next — one property, one team, one point of contact."
        image={IMAGES.spacious}
      >
        <CtaButton to="/submit-property" size="lg">Get Started</CtaButton>
      </PageHero>

      <section className="py-20 lg:py-28">
        <div className="mx-auto max-w-6xl px-4 lg:px-8">
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {STEPS.map((s, i) => (
              <Reveal key={s.n} delay={i * 80}>
                <div className="group relative h-full rounded-xl border border-slate-200 bg-white p-8 transition-all hover:border-gold/40">
                  <div className="font-display text-5xl font-bold text-slate-200 transition-colors group-hover:text-gold/40">{s.n}</div>
                  <h3 className="mt-4 text-lg font-semibold text-[#0B132B]">{s.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-slate-500">{s.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>

          <div className="mt-16 rounded-2xl border border-gold/25 bg-gradient-to-b from-white to-[#FBF9F1] p-10 text-center gold-glow">
            <h3 className="font-display text-2xl font-bold text-[#0B132B]">A New Investor Can Submit a Property in 3–5 Minutes.</h3>
            <p className="mx-auto mt-3 max-w-2xl text-sm text-slate-500">
              The same property record follows you from find to completed — no duplicate files for auction, financing, possession and rehab.
            </p>
            <div className="mt-6 flex flex-wrap justify-center gap-3">
              <CtaButton to="/submit-property">Submit a Property</CtaButton>
              <CtaButton to="/packages" variant="outline">View Packages</CtaButton>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
